
import moment from 'moment'
import util from '@/libs/util'
import common from '@/libs/common.mixin'
import wxjssdk from '@/libs/wxjssdk.mixin'
import VueVideo from 'c%/vueVideo.vue'
import SmallVoice from 'c%/SmallVoice.vue'
import FileItemVideo from './FileItemVideo.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import PhotoPackage from 'photoswipe-package'

export default{
mixins: [ common,wxjssdk ],
components: {
Previewer,
VueVideo,
SmallVoice,
FileItemVideo,
Flexbox,
FlexboxItem,
PhotoPackage
},
data () {
return {
imgPriview:false,
active_voice_id: 0,
imgList: []
}
},
directives: {
TransferDom
},
props: {
list: {
type: Array,
default: ()=>{
return []
}
},
fullWidth: {
type: Boolean,
default: false
},
is_qsjy: {
type: Boolean,
default: false
}
},
methods: {
setActiceVoiceId (item) {
this.active_voice_id = item.file_id
},
getFileImg (item) {
const suffixs = ['txt','doc','pdf','rar','zip','xls','ppt']
let type = item.file_type
if(type === 'pptx') {
type = 'ppt'
}
if(type === 'docx') {
type ='doc'
}
if(type === 'xlsx') {
type = 'xls'
}
if(suffixs.indexOf(type) > -1) {
return `https://sp1.xiao360.com/static/file/icon/${type}.png?imageView2/3/w/60/h/60`
}else{
return `https://sp1.xiao360.com/static/file/icon/default.png?imageView2/3/w/60/h/60`
}
},
previewVideo (item) {
this.$refs.playVideo
.set('video',item)
.show()
},
preview (item) {
let list = this.file_list('image')
let index = list.indexOf(item)

this.imgList = []
if(list.length){
list.forEach(l=>{



this.imgList.push(l.file_url)
})
}
this.previewShow = true




this.previewImage(item.file_url,this.imgList)
},
file_list (type) {
let [result,uploadList] = [[],this.list.filter(l=>l.file_url!=='')]
if(uploadList.length>0){
let filter = (item)=>{
if(typeof item.media_type == 'string'){
return item.media_type == type
}else{
type = this.getFileTypes(type)

return type.indexOf(item.file_type)>-1
}
}

result = uploadList.filter(filter)
}
return result
},
getFileTypes (type) {
if(type=='image'){
type = ['image','gif','jpg','jpeg','png','bmp','webp']
}else if(type=='voice'){
type = ['voice','mp3','wav','wma','ogg','aac','flac']
}else if(type=='video'){
type = ['video','mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv']
}else{
type = ['numbers','csv','xls','xlsx','keynote','ppt','pptx']
}
return type
}
},
computed: {
wrapClass () {
let length = this.file_list('image').length
return {
[`file-container`]: true,
[`file-container2`]:length==2,
[`file-container1`]:length==1||this.fullWidth
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/FileItem.vue